import React from 'react'
import {connect} from 'react-redux'
import {bindActionCreators} from 'redux'
import theme from '../../assets/react-toolbox/theme.js';
import ThemeProvider from 'react-toolbox/lib/ThemeProvider';
import {Route, Switch, withRouter} from "react-router-dom";

//IMPORT STYLE

import './dashboard.css'

// REDUX ACTIONS

//OWN COMPONENTS

import SideBar from './SideBar'
import ManageStations from './ManageStations';
import ViewAccount from './ViewAccount/ViewAccount'
import AdminOrganizations from './AdminOrganizations/AdminOrganizations'
import AdminNodes from "./AdminNodes/AdminNodes";
import AdminStation from "./AdminStations";

// import PopUp from "./PopUpNotification/PopUp";

import NotFound from "../Route/error404";


const DashBoard = (props) => {
    let indexContent = null;

    if (props.isAdmin)
        indexContent = AdminNodes;
    else
        indexContent = ManageStations;

    return (
        <div className="display-table" id="dashboardPage">
            <div className="row display-table-row">
                <SideBar/>
                <div className="col-sm-12 col-xs-12 dashboardContainer display-table-cell v-align">

                    {/*{props.dashboard.logOutPopUp &&*/}
                    {/*<ThemeProvider theme={theme}>*/}
                        {/*<div>*/}
                            {/*<PopUp active={props.dashboard.logOutPopUp}*/}
                                   {/*handlePopUp={props.dashboardActions.handleLogOut}*/}
                                   {/*title={'Session has expired'}*/}
                                   {/*popUpMSG={'Log in again if you want to continue using the platform.'}/>*/}
                        {/*</div>*/}
                    {/*</ThemeProvider>}*/}

                    <Switch>
                        <Route exact path={'/dashboard'} component={indexContent}/>
                        <Route path={'/stations'} component={ManageStations}/>
                        <Route path={'/organization'} component={AdminOrganizations}/>
                        <Route exact path={'/account'} component={ViewAccount}/>
                        <Route path={'/admin/stations'} component={AdminStation}/>
                        <Route path={'/admin/nodes'} component={AdminNodes}/>
                        <Route path={'/admin/organizations'} component={AdminOrganizations}/>
                        <Route path={'/admin/user'} component={AdminOrganizations}/>
                        <Route path='*' component={NotFound}/>
                    </Switch>
                </div>
            </div>
        </div>
    );
};

const dashboardStateToProps = (state) => {
    return {
        dashboard: state.dashboard,
        isAdmin: state.user.admin,

    }
};

// const dashboardDispatchToProps = (dispatch) => {
//     return {
//         dashboardActions: bindActionCreators(DashboardActions, dispatch),
//     }
// };


export default withRouter(connect(dashboardStateToProps, null)(DashBoard))


// WEBPACK FOOTER //
// ./src/components/DashBoard/index.js